module.exports = __webpack_public_path__ + "static/media/Planning Station SAMPLE.b23527bf.pdf";